import React from 'react';
import PropTypes from 'prop-types';

import { renderableType } from '../proptypes/prop-types';
import { buildClassNames, px } from '../util/utils';
import './circularProgress.scss';

const blockClassName = 'circularProgress';
const containerClassName = 'circularProgress__container';
const svgClassName = 'circularProgress__svg';
const circleBaseClassName = 'circularProgress__circle';

const circleSizeParam = 50;

/** A component for representing completion progress in the form of a circle */
export const CircularProgress = ({
                            children,
                            className,
                            circleClassName,
                            circleStyle,
                            show,
                            size,
                            thickness,
                            ...other
                          }) => (
  <div className={buildClassNames(className, blockClassName)} {...other}>
    {children}
    {show &&
      <div
        role='progressbar'
        className={containerClassName}
        style={{
          width: `calc(${px(size)} + calc(${px(thickness)} * 2))`,
          height: `calc(${px(size)} + calc(${px(thickness)} * 2))`,
          marginLeft: `calc((-${px(size)} - calc(${px(thickness)} * 2))/2)`,
          marginTop: `calc((-${px(size)} - calc(${px(thickness)} * 2))/2)`,
        }}
      >
        <svg className={svgClassName} viewBox={`0 0 ${circleSizeParam} ${circleSizeParam}`} >
          <circle
            className={buildClassNames(circleClassName, circleBaseClassName)}
            style={circleStyle}
            cx={circleSizeParam / 2}
            cy={circleSizeParam / 2}
            r={(circleSizeParam / 2) - 5}
            fill='none'
            strokeWidth={thickness}
          />
        </svg>
      </div>
    }
  </div>
);

CircularProgress.propTypes = {
  /** @ignore */
  children: renderableType,
  /** @ignore */
  className: PropTypes.string,
  /** The class name applied to the circular progress indicator */
  circleClassName: PropTypes.string,
  /** The styles appliead to the circular progress indicator */
  circleStyle: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  /** Maximum value for the progress indicator */
  max: PropTypes.number,
  /** Minimum value for the progress indicator */
  min: PropTypes.number,
  /** Indicates whether the progress indicator should be visible */
  show: PropTypes.bool,
  /** The diameter of the circular progress indicator before accounting for thickness */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /** The thickness of the circular progress indicator */
  thickness: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

CircularProgress.defaultProps = {
  max: 100,
  min: 0,
  size: '2rem',
  thickness: 3.6,
};

